import { ImageResponse } from 'types/Image'
import { InferType, object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  memberId: string().required(),
  pendingVisitId: string().required(),
})

export type Request = InferType<typeof Schema>
export type SuccessfulResponse = ImageResponse

export const url = ({ memberId, pendingVisitId }) => `/v2/members/${memberId}/images/pending_visit/${pendingVisitId}`
